import { createApp } from 'vue';
import { router } from './router';
import App from './App.vue';
import './styles.scss';
import { createPinia } from 'pinia';
import { initSentry } from './sentry';

const pinia = createPinia();
const app = createApp(App);
app.use(router);
app.use(pinia);

(async () => {
  // NB. helps App.vue get router vals onMounted
  await router.isReady();
  await initSentry(app, router); // ✅ guaranteed before mount
  app.mount('#app');
})();
